import { medlinkLLMService } from './llm/domain/medlink.llm.service';

/**
 * Legacy export for backward compatibility.
 * This now delegates to the Medlink Domain LLM Service.
 */
export const llmService = medlinkLLMService;
